<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'Intake-Estimate'"
    v-if="loaded"
    :defaultUserSettings="false"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../../templates/transaction-list";
import { IntakeEstimateService } from "../../../_services/api/purchasing/intake-estimate/intake-estimate.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      PurchaseOrderScreenVersion: "V1",
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Intake Estimate",
        // ScreenName: "Intake Estimate - All",

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoIntakeEstimateList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Intake Estimates",
                message: "Get Started, Add a Intake Estimate",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/intake-estimate/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "EstimateSeason",
              minWidth: 140,
              allowHiding: false,
              type: "Integer",
              filterIndex: 0,
            },
            {
              screenField: "EstimateDescription",
              type: "Text",
              filterIndex: 1,
            },
            {
              screenField: "EstimateDate",
              allowSearch: true,
              filterIndex: 2,
              sortOrder: "desc",
              sortIndex: 0,
            },
            {
              screenField: "EstimateOwner",
              type: "Text",
              filterIndex: 3,
            },
            {
              screenField: "TotalKg",
              // format: "Decimal-16-2",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              width: 50,
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Copy Estimate",
                      data: data,
                      clickAction: this.copyEstimate,
                      visible: true,
                    },
                    {
                      menuText: "Generate Purchase Forecast",
                      data: data,
                      clickAction: this.gereratePurchaseForecast,
                      visible: true,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (!data) return true;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "intake-estimate",
          mode: "review",
          idProperty: "RecordId",
        });
      }
    },

    async copyEstimate(e, grid) {
      await IntakeEstimateService.copyEstimate({
        RecordId: e.RecordId,
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          // this.$logger.debug("result ", result);
          grid.refresh(true);
        })
        .catch((error) => {
          this.displayServerError(error, "Copy Estimate Failed");
        });
    },

    async gereratePurchaseForecast(e) {
      await IntakeEstimateService.generatePurchaseForecast({
        IntakeEstimates: [{ RecordId: e.RecordId }],
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.showLoading(false);
          this.$notify(`Forecast generated successfully`, "success");
          // this.$logger.debug("result ", result);
          // grid.refresh(true);
        })
        .catch((error) => {
          this.displayServerError(error, "Forecast generation failed");
        });
    },
  },

  async created() {
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
